import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../post-auth-splash.css";

import { HOME_PATH } from "../config/products";
const LAUNCH_DURATION = 3400;

export default function PostAuthSplash() {
  const navigate = useNavigate();
  const location = useLocation();

  const to = location.state?.to || HOME_PATH;

  useEffect(() => {
    const timer = window.setTimeout(() => {
      navigate(to, { replace: true });
    }, LAUNCH_DURATION);

    return () => window.clearTimeout(timer);
  }, [navigate, to]);

  return (
    <main className="brand-launch" aria-label="Opening BetBond">
      <div className="brand-launch-stage" aria-hidden>
        <span className="brand-launch-halo" />
        <span className="brand-launch-ring">
          <span className="brand-launch-sweep-point" />
        </span>
        <span className="brand-launch-mote brand-launch-mote-one" />
        <span className="brand-launch-mote brand-launch-mote-two" />
        <span className="brand-launch-mote brand-launch-mote-three" />
        <span className="brand-launch-core">B</span>
      </div>
      <div className="brand-launch-wordmark">
        <span>Bet</span><span className="brand-launch-bond">Bond</span>
      </div>
      <div className="brand-launch-tagline" aria-hidden>
        <span className="brand-launch-tag-word brand-launch-tag-word-one">Define</span>
        <i className="brand-launch-tag-divider brand-launch-tag-divider-one" />
        <span className="brand-launch-tag-word brand-launch-tag-word-two">Match</span>
        <i className="brand-launch-tag-divider brand-launch-tag-divider-two" />
        <span className="brand-launch-tag-word brand-launch-tag-word-three">Settle</span>
      </div>
      <span className="sr-only" aria-live="polite">Opening BetBond</span>
    </main>
  );
}
